module.exports = __webpack_public_path__ + "img/扎克-摩尔.bb1a3068.png";